import styled, { css } from 'styled-components';

export const Circle = styled.button(
  ({ theme }) => css`
    position: relative;
    flex-shrink: 0;
    width: ${theme.sz.s24};
    height: ${theme.sz.s24};
    padding: 0;
    overflow: hidden;
    border: ${theme.bo.thickWidth} solid ${theme.co.neutral99};
    border-radius: ${theme.bo.elliptical};
    background-color: ${theme.co.neutral10};
    box-shadow: 0 ${theme.sz.s1} ${theme.sz.s4} hsla(0, 0%, 0%, 0.15);
    cursor: pointer;

    ${theme.focusVisible};

    @media (max-width: ${theme.sz.md}) {
      width: ${theme.sz.s16};
      height: ${theme.sz.s16};
    }
  `,
);

export const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const PlayIcon = styled.span(
  ({ theme }) => css`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.co.primary20};
    font-size: ${theme.sz.s5};
    pointer-events: none;
  `,
);
